export default "__VITE_ASSET__7YT5xv8l__"